import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider, SidebarTrigger } from "./ui/sidebar";
import { MobileNav } from "./MobileNav";
import { InstallPrompt } from "./pwa/InstallPrompt";
import { useIsMobile } from "@/hooks/use-mobile";

const Layout = () => {
  const isMobile = useIsMobile();
  return (
    <SidebarProvider defaultOpen>
      <div className="min-h-[100svh] bg-background flex w-full">
        <Header className="fixed top-0 left-0 right-0 z-50 px-2 sm:px-3">
          <div className="flex items-center gap-2">
            {!isMobile && <SidebarTrigger />}
          </div>
        </Header>
        <div className="flex w-full">
          {!isMobile && <AppSidebar />}
          <main
            className="flex-1 h-[100svh] md:pt-16 overflow-x-hidden overflow-y-auto min-w-0 max-w-full"
            style={{
              paddingTop: isMobile ? "calc(env(safe-area-inset-top) + 3.5rem)" : undefined,
              paddingBottom: isMobile ? "calc(env(safe-area-inset-bottom) + 3.5rem)" : undefined,
            }}
          >
            <Outlet />
          </main>
        </div>
        <MobileNav />
        <InstallPrompt />
      </div>
    </SidebarProvider>
  );
};

export default Layout;
